<div class="row mt-2 mr-1">
    <div class="col-12">
        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="payerBillingGridItemAdvancedSwitch" [storageKey]="'payer-billing-list-item'"
                (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
        </div>
    </div>
</div>
<div class="mt-2 ml-3 mr-3">
    <kendo-grid #grid [data]="gridView" [navigable]="true"
        [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
        [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
        [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
        [kendoGridSelectBy]="'id'" [selectedKeys]="selectedRecordKeys" (columnReorder)="onReorder($event)"
        (columnResize)="onResize($event)" (columnVisibilityChange)="onVisibilityChange($event)"
        (selectedKeysChange)="onSelectedKeysChange($event)" [selectable]="{ mode: 'multiple'}"
        (dataStateChange)="dataStateChange($event);" (selectionChange)="onSelectionChange($event)"
        (edit)="invoiceItemEditHandler($event)" (save)="updateInvoiceItem($event)"
        (cancel)="view.cancelHandler($event)">
        <kendo-grid-messages noRecords="{{ 'NO-RECORDS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="20" class="text-center"
            headerClass="text-center" *ngIf="invoice.invoiceStatus === 'PROCESSED'">
            <ng-template kendoGridHeaderTemplate>
                <div class="w-100">
                    <input id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
                        (selectAllChange)="onSelectAllChange($event)" type="checkbox" kendoCheckBox />
                    <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
                </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                <input *ngIf="canRebuildInvoiceItem(dataItem.invoiceItemStatus)" [kendoGridSelectionCheckbox]="idx"
                    type="checkbox" kendoCheckBox />
            </ng-template>
        </kendo-grid-checkbox-column>
        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
            <button kendoButton (click)="resetGridColumns()" class="float-right">
                {{'RESET-GRID-COLUMNS' | translate }}
            </button>
            <button kendoButton (click)="refresh()" class="float-right">
                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
            </button>
            <button type="button" kendoGridExcelCommand [disabled]="count === 0">
                {{'EXPORT-TO-EXCEL' | translate }}<i class="fal fa-file-excel" style="width: 15px;color:white"></i>
            </button>
            <button *ngIf="invoice.invoiceStatus === 'PROCESSED' && getSelectedCount()" class="float-right" kendoButton
                [primary]="true" type="button" (click)="openRebillInvoiceItemsDialogOpened()">
                {{'REBILL-RECORDS' | translate }}<span
                    *ngIf="invoice.invoiceStatus === 'PROCESSED' && getSelectedCount() > 0"
                    class="ml-1">({{getSelectedCount()}})</span>
            </button>
        </ng-template>
        <ng-container *ngFor="let col of view.columnsConfig">
            @if (col.field === 'remarkCode') {
            <!--Remark-->
            <kendo-grid-column-group title="{{ 'REMARK' | translate }}">
                <!--Remark Code-->
                <kendo-grid-column field="remarkCode" title="{{'CODE' | translate }}" [width]="col.width"
                    [filter]="col.filter" [format]="col.format"
                    [filterable]="col.filterable !== undefined ? col.filterable : true"
                    [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="false"
                    [class]="col.class ? col.class : ''">
                </kendo-grid-column>
                <!--Remark Description-->
                <kendo-grid-column field="remarkDescription" title="{{'DESCRIPTION' | translate }}" [width]="col.width"
                    [filter]="col.filter" [format]="col.format"
                    [filterable]="col.filterable !== undefined ? col.filterable : true"
                    [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="false"
                    [class]="col.class ? col.class : ''">
                </kendo-grid-column>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remarkCode">{{ dataItem.remarkCode }}</span>
                    <p *ngIf="dataItem.remarkDescription">{{ dataItem.remarkDescription }}</p>
                </ng-template>
            </kendo-grid-column-group>
            }
            @else if (!col.field.includes('remark'))
            {
            <kendo-grid-column [field]="col.field" [title]="col.title" [width]="col.width" [filter]="col.filter"
                [editor]="col.editor" [format]="col.format"
                [filterable]="col.filterable !== undefined ? col.filterable : true"
                [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="col.field === 'id' ? false : true"
                [class]="col.filter === 'boolean' ? 'text-center' : (col.class ? col.class : '')">
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.filter === 'boolean'">
                    <i *ngIf="dataItem[col.field] && col.field === 'valid'" class="fas fa-check-circle valid-status">
                    </i>
                    <i *ngIf="!dataItem[col.field] && col.field === 'valid'" class="fas fa-times-circle invalid-status">
                    </i>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'invoiceItemStatus'">
                    <span title="{{dataItem.invoiceItemStatusText}}">{{dataItem.invoiceItemStatusText}}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'adjustmentStatus'">
                    <span title="{{dataItem.adjustmentStatusText}}">{{dataItem.adjustmentStatusText}}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'payerBillingIdentifier'">
                    <span style="white-space: pre-line" title="{{dataItem.payerBillingIdentifierText}}">{{dataItem.payerBillingIdentifierText}}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'units'">
                    <span
                        [ngStyle]="((dataItem.adjustmentStatus === 'VOID_BY_ADJUSTMENT' && dataItem.units < 0) || (dataItem.adjustmentStatus === 'VOID')) ? {'color': '#dc5d3f', 'font-weight': 'bold'} : {'color': 'green', 'font-weight': 'bold'}">{{dataItem.units}}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'billedAmount'">
                    <span
                        [ngStyle]="((dataItem.adjustmentStatus === 'VOID_BY_ADJUSTMENT' && dataItem.billedAmount < 0) || (dataItem.adjustmentStatus === 'VOID')) ? {'color': '#dc5d3f', 'font-weight': 'bold'} : 
                                   (dataItem.adjustmentStatus === 'ADJUSTMENT' && dataItem.billedAmount > 0) ? {'color': 'green', 'font-weight': 'bold'} : {'color': 'black', 'font-weight': 'normal'}">{{dataItem.billedAmount
                        | number : '1.2-2'}}</span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'invoiceItemStatus'">
                    <app-dropdown-filter [filter]="filter" [data]="invoiceItemStatuses" filterField="invoiceItemStatus"
                        selectDefaultText="{{ 'SELECT-STATUS' | translate }}" textField="label"
                        valueField="ordinalValue">
                    </app-dropdown-filter>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column"
                    *ngIf="col.filter === 'numeric'">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>
            }
        </ng-container>
        <kendo-grid-command-column [width]="40" title="{{ 'ACTIONS' | translate }}" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
                <ng-container *ngIf="invoice.invoiceStatus === 'PROCESSED'">
                    <i *ngIf="(!dataItem.editing) && (invoice.invoiceStatus === 'PROCESSED') && (dataItem.invoiceItemStatus === 'DENIED' || dataItem.invoiceItemStatus === 'CANCELED' || dataItem.invoiceItemStatus === 'VOID' || dataItem.invoiceItemStatus === 'PENDING')"
                        class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}"
                        (click)="invoiceItemEditButton.click.emit($event); dataItem.editing = true;">
                    </i>
                    &nbsp;
                    <i *ngIf="(!dataItem.editing) && (dataItem.invoiceItemStatus === 'NOT_ELIGIBLE')"
                        class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem, invoice.invoiceStatus)">
                    </i>
                    <button kendoGridEditCommand #invoiceItemEditButton class="d-none"></button>
                </ng-container>
                <ng-container *ngIf="invoice.invoiceStatus === 'ERROR'">
                    <i *ngIf="(!dataItem.editing) && (!dataItem.valid)"
                        class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem, invoice.invoiceStatus)">
                    </i>
                    <button kendoGridEditCommand #invoiceItemEditButton class="d-none"></button>
                </ng-container>
                <ng-container *ngIf="dataItem.editing && invoice.invoiceStatus === 'PROCESSED'">
                    <ng-container *ngIf="invoiceItemFormGroup.valid">
                        <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                            (click)="invoiceItemSaveButton.click.emit($event); dataItem.editing = false;">
                        </i>
                        &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                        (click)="invoiceItemCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #invoiceItemSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #invoiceItemCancelButton class="d-none"></button>
                </ng-container>
            </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-excel [fileName]="excelFileName" [fetchData]="allData"></kendo-grid-excel>
    </kendo-grid>
</div>

<!-- Rebill invoice items dialog -->
<kendo-dialog *ngIf="rebillInvoiceItemsDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="cancelRebillInvoiceItems()">
    <p>{{'CONFIRM-INVOICE-ITEMS-REBILL' | translate}}</p>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelRebillInvoiceItems()">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="rebillInvoiceItems()">
            {{'YES' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p *ngIf="deleteRecordForErrorInvoice">{{ 'CONFIRM-INVOICE-ITEM-DELETION' | translate }}</p>
    <p *ngIf="!deleteRecordForErrorInvoice">{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedInvoiceItemName}}</span>
    <p *ngIf="deleteRecordForErrorInvoice"><span class="k-font-weight-bold">{{ 'CASE-ID-NUMBER' | translate }}: {{selectedInvoiceItemCaseId}}</span></p>
    <div *ngIf="deleteRecordForErrorInvoice">
        <div>
            <input type="radio" value="DELETE_INVOICE_RECORD_ONLY"
                name="deleteInvoiceOption"
                [(ngModel)]="deleteInvoiceOption"
                id="radioDeleteInvoiceRecordOnly" kendoRadioButton />
            <label class="k-radio-label" for="radioDeleteInvoiceRecordOnly">{{'DELETE-INVOICE-RECORD-ONLY' |
                translate}}
            </label>
        </div>
        <div>
            <input type="radio" value="DELETE_INVOICE_RECORD_AND_CASE_BILLABLE"
                name="deleteInvoiceOption"
                [(ngModel)]="deleteInvoiceOption"
                id="radioDeleteCaseBillables" kendoRadioButton />
            <label class="k-radio-label" for="radioDeleteCaseBillables">{{'DELETE-INVOICE-RECORD-AND-CASE-BILLABLE' |
                translate:patientLabel}}
            </label>
        </div>
    </div>    
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>